{
  "shell.couldNotVerify.body": "Vi kunde inte verifiera ditt medlemskap just nu. Försök logga in igen om en stund.",
  "shell.couldNotVerify.heading": "Medlemskapet kunde inte verifieras",
  "shell.couldNotVerify.logout": "Logga ut",
  "shell.couldNotVerify.retry": "Försök igen",
  "shell.desktopSidebar.navLabel": "Sidomeny",
  "shell.desktopSidebar.homeLink": "Till startsidan",
  "shell.desktopSidebar.languageSwitcher.label": "Byt språk",
  "shell.desktopSidebar.feeOverdueMarker": "Medlemsavgiften obetald",
  "shell.desktopSidebar.opensInNewTab": "öppnas i en ny flik",
  "shell.footer.copy": "Oma+ — demoversion, inte produktion.",
  "shell.noMembershipBlock.benefit1": "En juridisk följeslagare (Lakikaveri) i arbetsfrågor",
  "shell.noMembershipBlock.benefit2": "Olycksfallsförsäkring på fritiden i Finland och utomlands",
  "shell.noMembershipBlock.benefit3": "Yrkesmässig rättsskydds- och ansvarsförsäkring",
  "shell.noMembershipBlock.benefit4": "Tusentals nätkurser",
  "shell.noMembershipBlock.benefit5": "Personlig karriärcoachning",
  "shell.noMembershipBlock.benefit6": "Mångsidiga rabatter till exempel på hotell, motionsförmåner och cybersäkerhet",
  "shell.noMembershipBlock.benefitsIntro": "Som medlem i YTK Työelämä får du:",
  "shell.noMembershipBlock.body": "Du har inget giltigt medlemskap i YTK Työelämä och kan därför inte använda tjänsten.",
  "shell.noMembershipBlock.heading": "Inget medlemskap i YTK Työelämä",
  "shell.noMembershipBlock.joinLinkLabel": "ytkpalvelut.fi/liity-jaseneksi",
  "shell.noMembershipBlock.joinPrefix": "Du kan bli medlem i YTK Työelämä på ",
  "shell.noMembershipBlock.logout": "Logga ut",
  "shell.menu.close": "Stäng menyn",
  "shell.menu.cms": "CMS",
  "shell.menu.description": "Sekundär meny: tjänstenavigering, språk, utloggning och CMS-åtkomst.",
  "shell.menu.languagePicker.label": "Språk",
  "shell.menu.languagePicker.fi": "Suomi",
  "shell.menu.languagePicker.en": "English",
  "shell.menu.languagePicker.sv": "Svenska",
  "shell.menu.legal.privacyPolicy": "Dataskyddsbeskrivning",
  "shell.menu.legal.termsOfUse": "Användarvillkor",
  "shell.menu.lakikaveri.children.lakiruutu": "Lakiruutu",
  "shell.menu.lakikaveri.children.tutustuLakikaveriin": "Lär känna Lakikaveri",
  "shell.menu.lakikaveri.label": "Lakikaveri",
  "shell.menu.navLabel": "Webbplatsfunktioner",
  "shell.menu.otaYhteytta.label": "Kontakta oss",
  "shell.menu.palvelutEdut.children.edutAlennukset": "Förmåner och rabatter",
  "shell.menu.palvelutEdut.children.verkkokoulutuspalvelu": "Nätutbildningstjänst",
  "shell.menu.palvelutEdut.label": "Medlemskap och förmåner",
  "shell.menu.signIn": "Logga in",
  "shell.menu.signOut": "Logga ut",
  "shell.menu.submenuSuffix": "undermeny",
  "shell.menu.tapaturmavakuutus.label": "Olycksfallsförsäkring",
  "shell.menu.title": "Meny",
  "shell.menu.userChip.demoBadge": "demo",
  "shell.menu.userChip.memberNumberPrefix": "Medlemsnummer:",
  "shell.menu.userChip.openProfile": "Öppna Mina uppgifter",
  "shell.primaryNav.koti": "Hem",
  "shell.primaryNav.label": "Huvudnavigering",
  "shell.primaryNav.omatTiedot": "Mina uppgifter",
  "shell.primaryNav.unreadBadge": "Olästa meddelanden: {n}",
  "shell.primaryNav.viestit": "Meddelanden",
  "shell.session.signingOut": "Loggar ut…",
  "shell.session.signOutFailed": "Utloggningen misslyckades. Din session kan fortfarande vara aktiv. Försök logga ut igen.",
  "shell.session.retrySignOut": "Försök logga ut igen",
  "shell.session.accountReplaced": "Ett annat konto loggade in i den här webbläsaren. Sidan laddas om…",
  "shell.session.reload": "Ladda om sidan",
  "shell.session.loading": "Kontrollerar inloggningen…",
  "shell.skipLink.label": "Hoppa till huvudinnehållet",
  "shell.topBar.menuLabel": "Öppna menyn"
}
